/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import RentalComponent from './main';
import EditRentalComponent from './edit/main';

export const rental = (context, next) => {
    context.primary = <RentalComponent />;
    next();
};

export const editRental = (context, next) => {
    context.primary = <EditRentalComponent />;
    next();
};